
import { Component, Vue } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import { getCompanyDtl, jump2Quota, jump2Repayment, toQuotaResDto } from '@/api/customerManage'
import { openNewPage } from '@/utils/h5ToApp'
import { getRegulations } from '@/api/guarantee'

Component.registerHooks(['beforeRouteEnter'])
@Component({
  name: 'description',
  components: {}
})
export default class Authorize extends Vue {
  @Getter companyId!: string
  @Getter mobile!: string
  @Getter userId!: string

  textmsg = ''
  url = '' 
  times = 5 // 倒计时

  created () {
    this.url = this.$route.query.url as string
    this.getRegulations()
  }

  getRegulations () {
      getRegulations({companyId: this.$route.query.merchantId}).then(res => {
        this.textmsg = res.data.content
      })
  }

  sureFunc () {
    console.log('this.url', this.url)
    this.toFreeLogin(this.url)
  }

  /**
   * 跳转到免登录页面
   * @param url 路径
   */
  toFreeLogin (url:any) {
      openNewPage({url})
  }
}
